import { useState } from "react";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import wide_view from "assets/common/company/wide_view_white.png";

const branchesData = [
    {
        name: "일신본사 (국제사업본부)",
        managers: "홍찬종 부사장, 김종범 과장, 김명준 사원",
        phone: "1588-0605",
        address: "고양시 덕양구 행주외동",
        regions: "뉴욕 / LA / 중국 / 베트남 / 홍콩 / 두바이 /, 독일 / 영국 / 프랑스 / 이태리 / 그외 전세계 국가, 국제특송운송 및 카고운송",
    },
    {
        name: "일신본사 (전시사업본부)",
        managers: "김대일 이사, 김종범 과장",
        phone: "1588-0605",
        address: "고양시 덕양구 행주외동",
        regions: "국내 / 아시아 / 유럽 / 미주 / 중동, 각종 국내·해외 전시회 운송",
    },
    {
        name: "일신본사 (국내사업본부)",
        managers: "이경태 상무, 권동현 이사",
        phone: "1566-0685",
        address: "고양시 덕양구 행주외동",
        regions: "서울·경기 수도권 전지역 모닝택배 /, 전국익일택배",
    },
    {
        name: "일신본사 (퀵사업본부)",
        managers: "이대성 본부장, 김정란 부장",
        phone: "1661-1116",
        address: "고양시 덕양구 행주외동",
        regions: "서울·경기 수도권 전지역 퀵서비스 /, 화물서비스",
    },
    {
        name: "일신대구지사",
        managers: "정해섭 과장, 백현숙 부장",
        phone: "053-573-6776",
        address: "대구시 서구 이현동",
        regions: "대구 / 구미 / 칠곡 / 성주 / 고령 / 경산 / 영천, 국제특송운송 및 카고운송 & 모닝택배",
    },
    {
        name: "북부영업본부",
        managers: "홍찬종 부사장",
        phone: "070-4818-1559",
        address: "경기도 양주시 산북동",
        regions: "양주 / 포천 / 동두천 / 연천 / 의정부, 국제운송·모닝택배·모닝퀵서비스",
    },
    {
        name: "남부영업본부",
        managers: "홍찬종 부사장",
        phone: "070-4818-1574",
        address: "경기도 안산시 성곡동",
        regions: "안산 / 시흥 / 화성 / 수원 / 안성 / 평택, 국제운송·모닝택배·모닝퀵서비스",
    },
    {
        name: "동부영업본부",
        managers: "김만년 이사",
        phone: "070-4818-1580",
        address: "경기도 하남시 초일동",
        regions: "송파 / 강동 / 하남 / 성남 / 구리 / 남양주 / 용인 / 광주 / 그외 동부지역, 국제운송·모닝택배·모닝퀵서비스",
    },
    {
        name: "서부영업본부",
        managers: "이경태 상무",
        phone: "010-9496-2797",
        address: "경기도 부천시 원종동",
        regions: "부천 / 인천 / 김포 / 안양 / 그외 서부지역, 국제운송·모닝택배·모닝퀵서비스",
    },
    {
        name: "동대문 영업본부",
        managers: "권정성 부사장",
        phone: "070-4818-1571",
        address: "서울시 종로구 종로6가",
        regions:
            "동대문종합시장 / 방산시장 / 동화상가 / 종로 / 을지로 /, 주교동 / 효제동 / 그외 동대문주변지역, 국제운송·모닝택배·모닝퀵서비스",
    },
    {
        name: "의정부 영업본부",
        managers: "유항식 소장",
        phone: "010-3667-2124",
        address: "경기도 의정부시 금오동",
        regions: "의정부 / 일산 / 고양 / 파주, 국제운송·모닝택배·모닝퀵서비스",
    },
    {
        name: "부산 영업본부",
        managers: "류지운 대표",
        phone: "010-2969-2773",
        address: "부산 강서구 대저동",
        regions: "부산 / 경남 양산, 모닝택배",
    },
];
const overseasBranchesData = [
    {
        name: "일신 NEWYORK",
        managers: "김창남 지사장",
        phone: "201-396-6997",
        address: "247W. 38TH ST. SUTIE 405 NEW YORK NY 10018 USA",
    },
    {
        name: "일신 LOS ANGELES",
        managers: "지서진 대리",
        phone: "323-235-5000",
        address: "361 E.JEFFERSON BLVD. LA CA 90011 USA",
    },
    {
        name: "일신 HONGKONG",
        managers: "박 혁 부장",
        phone: "852-2619-9878",
        address: "UNIT 11,3/F, WING FAT IND BLDG,12 WANG TAI ROAD, KOWLOON BAY, HONGKONG",
    },
    {
        name: "일신 VIETNAM",
        managers: "남인재 과장, 김건우 계장",
        phone: "84-28-3948-3877, 84-24-2246-4828",
        address:
            "71 Tan Quoc HoanSt., Ward 4, Tann Binh Dist., Ho Chi Minh City / B4-09, Vinhomes Gardenia, Ham Nghi road, Cau Dien ward, Nam Tu Liem dist, Ha Noi city",
    },
    {
        name: "일신 CHINA",
        managers: "이상권 부장, 교지곤 경리",
        phone: "20-3622-9516, 021-5449-1925",
        address:
            "NO18, YUNTIANCUITING, 157-165 GANGBEI ROAD, BAIYUN GU, GUANGZHOU,/ GUANGDONG, CHINA / Laifang road no. 2000, no.3, no. 42-50, jiuting town, songjiang district, Shanghai",
    },
    {
        name: "일신 DUBAI",
        managers: "Hanish Kumar",
        phone: "9714-2630380",
        address: "AL MAZOON BLDG P.O BOX 19080 AL GHUSAIS DUBAI",
    },
    {
        name: "일신 GERMANY",
        managers: "Sparrow",
        phone: "49-176-8063-8944",
        address: "WORLDLINK EXPRESS GMBH, KELSTERBACHER STRASSE 20, 65479 RAUNHEIM, GERMANY",
    },
    {
        name: "일신 U.K",
        managers: "조현주 이사",
        phone: "070-4207-2614",
        address: "UNIT 5 DEVONSHIRE COURT, VICTORIA ROAD, FELTHAM TW13 7LU, UK",
    },
    {
        name: "일신 FRANCE",
        managers: "김정하 차장",
        phone: "33-1-8299-0082",
        address: "FC LOGISTIQUE, 10 AVENUE DU VALQUIOU, 93290 TREMBLAY EN, FRANCE",
    },
    {
        name: "일신 ITALY",
        managers: "이호진 대표",
        phone: "39-340-665-2524",
        address: "VIA DEL GLADIOLO 5, 20090 SEGRATE (MI) ITALY",
    },
];

const Branch = () => {
    const [branch, setBranch] = useState<number>(1);
    const [isScrolled, setIsScrolled] = useState<boolean>(false);
    const responsive1100 = useMediaQuery(1100);

    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">BRANCH</p>
            <div className="bg-white w-full max-w-[1200px] p-[50px] flex flex-col responsive1200:px-[4%]">
                <div className="flex items-center text-[17px] w-full relative">
                    <div className="flex h-12">
                        <button
                            onClick={() => setBranch(1)}
                            className={`w-[250px] flex items-center justify-center h-12 text-nowrap responsive1200:px-[20px] responsive1200:text-[15px] responsive1200:flex-1 responsive1200:w-[auto] responsive650:px-[10px] relative ${
                                branch === 1
                                    ? "border-y-2 border-x-2 pt-0.5 border-[#264180] border-b-0"
                                    : "border-l-2 border-t-2 border-b-2 border-b-[#264180] pt-1 pr-0.5 text-[#666]"
                            }`}
                        >
                            국내지사 및 영업본부
                            {branch === 1 && <span className="absolute left-0 bottom-0 w-full border-b-2 border-white z-[22]" />}
                        </button>
                        <button
                            onClick={() => setBranch(2)}
                            className={`w-[250px] flex items-center justify-center h-12 text-nowrap responsive1200:px-[20px] responsive1200:text-[15px] responsive1200:flex-1 responsive1200:w-[auto] responsive650:px-[10px] relative ${
                                branch === 2
                                    ? "border-y-2 border-x-2 pt-0.5 border-[#264180] border-b-0"
                                    : "border-r-2 border-t-2 border-b-2 border-b-[#264180] pt-1 pl-0.5 text-[#666]"
                            }`}
                        >
                            해외지사 및 파트너
                            {branch === 2 && <span className="absolute left-0 bottom-0 w-full border-b-2 border-white z-[22]" />}
                        </button>
                    </div>
                    <div className="absolute left-0 bottom-0 w-full border-b-2 border-[#264180]" />
                </div>
                <div key={branch} className="animate-fade-in overflow-x-auto relative" onScroll={() => setIsScrolled(true)}>
                    {responsive1100 && (
                        <div
                            className={`${isScrolled ? "opacity-[0] pointer-events-none" : "opacity-[1] pointer-events-auto"} transition-opacity duration-[0.3s] absolute top-1/2 left-1/2 -translate-x-1/2 text-white bg-black/60 rounded-[10px] px-[10px] py-[20px] flex flex-col items-center gap-[10px]`}
                        >
                            <img src={wide_view} alt="" />
                            좌,우로 움직여보세요
                        </div>
                    )}

                    <div className="min-w-[940px]">
                        <div className="mt-12 mb-6 flex items-center gap-2">
                            <div className="h-[18px] w-[3px] bg-[#264180]" />
                            <p className="text-[17px] text-[#333] font-[500] pt-[1px]">
                                {branch === 1 ? "국내지사 및 영업본부" : "해외지사 및 파트너"}
                            </p>
                        </div>
                        {branch === 1 ? (
                            <table className="text-[15px] text-[#333] w-full border-collapse border-spacing-0">
                                <thead>
                                    <tr className="h-[47px] bg-[#4d5d81] text-white">
                                        <th className="font-[400] w-[198px] border-r border-[#ddd]">지점명</th>
                                        <th className="font-[400] w-[132px] border-r border-[#ddd]">담당자</th>
                                        <th className="font-[400] w-[132px] border-r border-[#ddd]">전화번호</th>
                                        <th className="font-[400] w-[198px] border-r border-[#ddd]">주소</th>
                                        <th className="font-[400] w-[445px]">관할 주요지역 및 업무</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {branchesData.map((branch, index) => (
                                        <tr key={index} className="text-center">
                                            <td className="border-r border-b border-gray-200 p-[10px] bg-[#f8f8f8]">{branch.name}</td>
                                            <td className="border-r border-b border-gray-200 p-[10px]">
                                                {branch.managers.split(", ").map((manager, i) => (
                                                    <div key={i}>{manager}</div>
                                                ))}
                                            </td>
                                            <td className="border-r border-b border-gray-200 p-[10px] font-[600] text-[#1744ad] text-[14.5px] whitespace-nowrap">
                                                {branch.phone}
                                            </td>
                                            <td className="border-r border-b border-gray-200 p-[10px]">{branch.address}</td>
                                            <td className="border-b border-gray-200 p-[10px]">
                                                {branch.regions.split(", ").map((region, i) => (
                                                    <div key={i}>{region}</div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <table className="text-[15px] text-[#333] w-full border-collapse border-spacing-0">
                                <thead>
                                    <tr className="h-[48px] bg-[#4d5d81] text-white ">
                                        <th className="w-[176px] border-r border-[#ddd]">지점명</th>
                                        <th className="w-[143px] border-r border-[#ddd]">담당자</th>
                                        <th className="w-[165px] border-r border-[#ddd]">전화번호</th>
                                        <th className="w-[616px] border-r border-[#ddd]">주소</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {overseasBranchesData.map((branch, index) => (
                                        <tr key={index} className="text-center">
                                            <td className="border-r border-b border-gray-200 p-[10px] bg-[#f8f8f8]">{branch.name}</td>
                                            <td className="border-r border-b border-gray-200 p-[10px]">
                                                {branch.managers.split(", ").map((manager, i) => (
                                                    <div key={i}>{manager}</div>
                                                ))}
                                            </td>
                                            <td className="border-r border-b border-gray-200 p-[10px] font-[600] text-[#1744ad] text-[14.5px]">
                                                {branch.phone.split(", ").map((phone, i) => (
                                                    <div key={i}>{phone}</div>
                                                ))}
                                            </td>
                                            <td className="border-b border-gray-200 py-[10px] text-[14.5px]">
                                                {branch.address.split("/ ").map((address, i) => (
                                                    <div key={i}>{address}</div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Branch;
